import React, { ReactElement } from 'react';

interface CampaignAlertCountBadgeProps {
  count: number;
  className?: string;
}

const CampaignAlertCountBadge = ({ count, className = '' }: CampaignAlertCountBadgeProps): ReactElement | null => {
  if (count <= 0) return null;

  return (
    <span
      className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-xs font-semibold leading-none ${className}`}
      data-testid="campaign-alert-count-badge"
      aria-label={`${count} campaigns with stalled generation`}
    >
      {count}
    </span>
  );
};

export default CampaignAlertCountBadge;
